import SetPostAsSeenError from './SetPostAsSeenError';
class PostIsNotRegistered extends SetPostAsSeenError {
    postId;
    constructor(postId, options) {
        super('Post is not registered', options);
        this.postId = postId;
    }
}
export default PostIsNotRegistered;
